<div class="contents">
  <app-back-button></app-back-button>
  <br>

  <div class="w-full-details">
    <div class="modal-header">
      <div class="icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z">
          </path>
        </svg>
      </div>
    </div>
    <div class="bolsa-info-title">
      <h3>Informação do Auxílio de Formação</h3>
    </div>
    <div class="bolsa-info-content">
      <div class="p-fluid grid">
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Tipo de Bolsa</span>
            <h4 class="title">{{bolsa?.tipoBolsaDescricao}}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">País de Estudo</span>
            <h4 class="title">{{bolsa?.pais}}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Empresa Gestora</span>
            <h4 class="title">{{bolsa?.instituicaoGestora.nome}} </h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Nível Académico da Formação</span>
            <h4 class="title">{{ bolsa?.nivelAcademicoDescricao }}</h4>
          </div>
        </div>
      </div>
    </div>
    <div class="bolsa-info-title">
      <h3>Detalhes do Pedido</h3>
    </div>
    <div class="bolsa-info-content">
      <div class="p-fluid grid">
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Nome do Estudante</span>
            <h4 class="title">{{ bolsa?.bolseiro.nome }}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Bilhete de Identidade do Estudante</span>
            <h4 class="title">{{bolsa?.bolseiro.numeroBI}}</h4>
          </div>
        </div>
        <!-- <div class="col-3 mb-3">
          <div class="detalhes">
            <span class="sub-title">Data do Pedido</span>
            <h4 class="title">{{bolsa?.pedido?.dataPedido | date:'dd-MM-yyyy'}}</h4>
          </div>
        </div>
        <div class="col-3 mb-3">
          <div class="detalhes">
            <span class="sub-title">Data de Atribuição</span>
            <h4 class="title">{{ bolsa?.pedido?.dataAtribuicao | date:'dd-MM-yyyy' }}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Bilhete de Identidade do Requerente</span>
            <h4 class="title"> {{bolsa?.nifRequerente}} </h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Nome do Requerente</span>
            <h4 class="title">{{bolsa?.nomeRequerente}}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Email do Requerente</span>
            <h4 class="title">{{bolsa?.emailRequerente}}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Telefone do Requerente</span>
            <h4 class="title">{{bolsa?.telefoneRequerente}}</h4>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="detalhes">
            <span class="sub-title">Tipo de Pedido</span>
            <h4 class="title"> {{bolsa?.tipoPedidoDescricao}} </h4>
          </div>
        </div> -->
      </div>
    </div>


    <p-tabs value="0">
      <p-tablist>
        <p-tab value="0">
          <div class="bolsa-info-title">
            <h3>Fases de Formação</h3>
          </div>
        </p-tab>
        <p-tab value="1">
          <div class="bolsa-info-title">
            <h3>Renovações</h3>
          </div>
        </p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="bolsa-info-content">
            <app-search-bar [filters]="[]" [sortFields]="[]" primaryBtnLabel="Adicionar Fase da Formação"
              (onPrimaryBtnClick)="showAddFormacaoModal()"
              (formValueChange)="handleFormValueChange($event)"></app-search-bar>

            <div class="row">
              <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
                <app-table [pagination]="pagination" [columns]="columns" [actions]="actions"
                  (pageChange)="onPageChange($event)" (actionSelected)="onActionSelected($event)"></app-table>
              </ng-container>
              <ng-template #emptyTemplate>
                <div class="no-data">
                  <app-data-void titulo="Nehuma Fase da Formação encontrada"
                    descricao="Clique em Adicionar Fase de Formação para criar uma."></app-data-void>
                </div>
              </ng-template>
            </div>
          </div>
        </p-tabpanel>
        <p-tabpanel value="1">
          <div class="bolsa-info-content">
            <app-renovacao [idBolsa]="bolsaId"></app-renovacao>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>

    <p-dialog [modal]="true" [(visible)]="visible">
      <ng-template #headless>
        <div class="custom-modal-layout" style="width: 720px; padding: 1.25rem;">
          <div class="modal-header">
            <div class="icon">
              <img src="icons/plus-circle.svg" alt="Email Icon" />
            </div>
            <span class="title">Adicionar Fase de Formação</span>
            <p-button icon="pi pi-times" class="close-btn" [rounded]="true" [text]="true" (onClick)="visible = false" />
          </div>

          <form [formGroup]="institutionForm">
            <div class="p-fluid grid">
              <div class="field col-6">
                <label for="instituicaoEnsinoID">Instituição de Ensino</label>
                <p-dropdown [filter]="true" appendTo="body" [showClear]="true" id="instituicaoEnsinoID"
                  [options]="educationalInstitution" optionLabel="nome" formControlName="instituicaoEnsinoID"
                  optionValue="id" placeholder="Seleccione uma instituição de ensino" class="w-full"
                  (onChange)="onInstitutionChange($event)"></p-dropdown>
                <div
                  *ngIf="institutionForm.get('instituicaoEnsinoID')?.touched && institutionForm.get('instituicaoEnsinoID')?.invalid">
                  <small class="error-message"
                    *ngIf="institutionForm.get('instituicaoEnsinoID')?.errors?.['required']">Instituição
                    de Ensino é
                    obrigatória.</small>
                </div>
              </div>

              <div class="field col-6">
                <label for="curso">Fase</label>
                <p-dropdown [filter]="true" [showClear]="true" appendTo="body" id="fase" formControlName="faseCursoID"
                  [options]="listaFases" optionLabel="designacao" optionValue="id"
                  placeholder="Seleccione a fase de formação" class="w-full"
                  (onChange)="onFaseChange($event)"></p-dropdown>
                <div *ngIf="institutionForm.get('faseCursoID')?.touched && institutionForm.get('faseCursoID')?.invalid">
                  <small class="error-message" *ngIf="institutionForm.get('faseCursoID')?.errors?.['required']">A fase
                    de
                    formação é
                    obrigatória.</small>
                </div>
              </div>

              <div class="field col-6">
                <label for="unidadeOrganica" id="unidadeOrganicaLabel">Unidade Orgânica</label>
                <p-select [filter]="true" [showClear]="true" appendTo="body" id="unidadeOrganica"
                  formControlName="unidadeOrganicaID" [options]="listaUnidadesOrganicas" optionLabel="designacao"
                  optionValue="id" placeholder="Seleccione a unidade orgânica" class="w-full">
                </p-select>
                <div
                  *ngIf="institutionForm.get('unidadeOrganicaID')?.touched && institutionForm.get('unidadeOrganicaID')?.invalid">
                  <small class="error-message" *ngIf="institutionForm.get('unidadeOrganicaID')?.errors?.['required']">
                    A unidade orgânica é obrigatória.
                  </small>
                </div>
              </div>

              <div class="field col-6">
                <label for="curso">Curso</label>
                <p-dropdown [filter]="true" [showClear]="true" appendTo="body" id="curso"
                  formControlName="instituicaoEnsinoCursoID" [options]="instituicaoCursoList" optionLabel="nome"
                  optionValue="id" placeholder="Seleccione o curso" class="w-full"></p-dropdown>
                <div
                  *ngIf="institutionForm.get('instituicaoEnsinoCursoID')?.touched && institutionForm.get('instituicaoEnsinoCursoID')?.invalid">
                  <small class="error-message"
                    *ngIf="institutionForm.get('instituicaoEnsinoCursoID')?.errors?.['required']">Curso é
                    obrigatório.</small>
                </div>
              </div>

              <div class="field col-3">
                <label for="dataInicio">Data de Início</label>
                <p-datepicker appendTo="body" id="dataInicio" class="w-full" [showIcon]="true" dateFormat="dd/mm/yy"
                  placeholder="Data de Início" formControlName="dataInicio"></p-datepicker>
                <div *ngIf="institutionForm.get('dataInicio')?.touched && institutionForm.get('dataInicio')?.invalid">
                  <small class="error-message" *ngIf="institutionForm.get('dataInicio')?.errors?.['required']">Data de
                    Início é
                    obrigatória.</small>
                </div>
              </div>
              <div class="field col-3">
                <label for="dataFim">Data de Fim</label>
                <p-datepicker appendTo="body" id="dataFim" class="w-full" [showIcon]="true" dateFormat="dd/mm/yy"
                  placeholder="Data de Fim" formControlName="dataFim"></p-datepicker>
                <div *ngIf="institutionForm.get('dataFim')?.touched && institutionForm.get('dataFim')?.invalid">
                  <small class="error-message" *ngIf="institutionForm.get('dataFim')?.errors?.['required']">Data
                    de Fim é obrigatória.</small>
                </div>
                <div *ngIf="institutionForm.hasError('dateRange')" class="error-message">
                  Data de término não pode ser anterior à data de início
                </div>
              </div>

              <div class="field col-6">
                <label for="duracao">Duração da Formação</label>
                <input id="duracao" type="text" class="w-full" pInputText formControlName="duracao"
                  placeholder="Duração" />
                <div *ngIf="institutionForm.get('duracao')?.touched && institutionForm.get('duracao')?.invalid">
                  <small class="error-message" *ngIf="institutionForm.get('duracao')?.errors?.['required']">Duração é
                    obrigatória.</small>
                </div>
              </div>

              <div class="d-flex w-full justify-content-between">
                <button pButton type="button" label="Cancelar" class="p-button-outlined"
                  (click)="visible = false"></button>
                <button pButton type="button"
                  [label]="currentEditIndex != null ? 'Editar' : 'Adicionar Fase da Formação'" class="p-button-primary"
                  (click)="addInstituicao()">
                </button>
              </div>
            </div>
          </form>

        </div>
      </ng-template>
    </p-dialog>
  </div>
</div>
<p-toast></p-toast>
<p-confirmdialog></p-confirmdialog>